import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const omnitracsConfig: TSPConfig = {
  key: 'omnitracs',
  name: 'Omnitracs Xata XRS',
  imageName: 'Omnitracs Xata XRS',
  category: TSPCategory.CUSTOM,
  helpText: 'Please provide your Omnitracs Xata XRS credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Company Login ID',
          name: 'database',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default omnitracsConfig;
